import { Redirect, Route, useParams } from 'react-router'
import { Layout } from '../../components'
import { useSize } from '../../components/utils'
import { ACL, Routes } from '../../constants'
import { useAppSelector } from '../../reducers'
import { EstateUtils } from '../../utils'
import Promos, { PromosSubHeader } from './Promos'
import Credits from './Credits'
import TicketSizes from './TicketSizes'
import Variants from './Variants'
import DesktopHeader from './DesktopHeader'
import MobileHeader from './MobileHeader'

interface SelfServeRouteParams {
    estate: string;
    page: string;
}

export default function SelfServe() {
    const hasAccessToSelfServe = useAppSelector(
        (state) => EstateUtils.hasPermission(state, { acls: [ACL.VIEW_SELF_SERVE] }, { ignoreAdmin: true })
    )
    const { estate, page } = useParams<SelfServeRouteParams>()
    const { isMobile } = useSize()

    if (!hasAccessToSelfServe) {
        return <Redirect to={Routes.buildRoute(Routes.LANDING, { estate })} />
    }

    if (!page) {
        return <Redirect to={Routes.buildRoute(Routes.SELF_SERVE_PROMOS, { estate })} />
    }

    return (
        <>
            <Layout.Header>
                {isMobile && <MobileHeader />}
                {!isMobile && <DesktopHeader />}
            </Layout.Header>
            <Layout.SubHeader>
                <Route path={Routes.SELF_SERVE_PROMOS}><PromosSubHeader /></Route>
            </Layout.SubHeader>
            <Route path={Routes.SELF_SERVE_ACCOLADES}><div>ACCOLADES</div></Route>
            <Route path={Routes.SELF_SERVE_CREDITS}>
                <Credits />
            </Route>
            <Route path={Routes.SELF_SERVE_TICKET_SIZES}>
                <TicketSizes />
            </Route>
            <Route path={Routes.SELF_SERVE_VARIANTS}>
                <Variants />
            </Route>
            <Route path={Routes.SELF_SERVE_PROMOS}>
                <Promos />
            </Route>
        </>
    )
}
